module.exports = __webpack_public_path__ + "img/4-4.443b61fc.jpg";